import React,{ useEffect } from 'react'
import { useFilterContext } from '../context/filter_context';
import { useProductContext } from "../context/productcontext";
import GridView from './GridView';
import ListView from './ListView';
import { useSearchParams } from 'react-router-dom';
import { useLocation } from "react-router-dom";




const ProductList = () => {
  const location = useLocation();
  const{grid_view,updateFilterValue}=useFilterContext();
  const { products, isLoading } = useProductContext(); 
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
   const categoryFromURL = params.get("category");
    if (categoryFromURL) {
      updateFilterValue({
        target: {
          name: "category",
          value: categoryFromURL,
        },
      });
    }
  }, [location.search]);

  if (isLoading) {
    return <p>Loading products...</p>;
  }

  if (!products || products.length === 0) {
    return <p>No products found</p>;
  }


  if (grid_view===true){
    return <GridView products={products} />
  }
   if (grid_view===false){
   return <ListView products={products} />
   }
 
}

export default ProductList
